import { compose } from 'redux';

import type { DeviceConfigurationState } from '../deviceConfigurationStore';

export const selectDeviceConfigurationDomain = (state: DeviceConfigurationState) => state.deviceConfiguration;

export const selectDeviceConfigurationWebData = compose((state) => state.deviceConfigurationWebData, selectDeviceConfigurationDomain);

export const selectUpdateDeviceConfigurationRequestWebData = compose((state) => state.updateDeviceConfigurationRequestWebData, selectDeviceConfigurationDomain);

export const selectUpdateDeviceSpeedRequestWebData = compose((state) => state.updateDeviceSpeedRequestWebData, selectDeviceConfigurationDomain);
